module.exports = __webpack_public_path__ + "static/media/NO_APARTMENTS.2de96086.svg";